import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter } from 'mdb-react-ui-kit';

const GestionMateriales = () => {
  const [materials, setMaterials] = useState([
    { id: 1, name: "Plástico", category: "Polímero", unitPrice: 5 },
    { id: 2, name: "Vidrio", category: "Inorgánico", unitPrice: 3 },
    { id: 3, name: "Papel", category: "Celulósico", unitPrice: 2 },
  ]);
  const [filterText, setFilterText] = useState('');
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);

  const openAddMaterialModal = () => {
    setSelectedMaterial({ name: "", category: "", unitPrice: 0 });
    setIsEditing(false);
    toggleModal();
  };

  const openEditMaterialModal = (material) => {
    setSelectedMaterial(material);
    setIsEditing(true);
    toggleModal();
  };

  const handleSaveMaterial = () => {
    if (isEditing) {
      // Actualizar material existente
      setMaterials(materials.map(mat => mat.id === selectedMaterial.id ? selectedMaterial : mat));
    } else {
      // Agregar nuevo material
      const newMaterial = { ...selectedMaterial, id: materials.length + 1 };
      setMaterials([...materials, newMaterial]);
    }
    toggleModal();
  };

  const handleDeleteMaterial = (id) => {
    setMaterials(materials.filter(material => material.id !== id));
  };

  const columns = [
    { name: "ID", selector: row => row.id, sortable: true, width: "70px" },
    { name: "Nombre del Material", selector: row => row.name, sortable: true, grow: 2 },
    { name: "Categoría", selector: row => row.category, sortable: true, grow: 2 },
    {
      name: "Precio por Unidad ($/kg)",
      selector: row => row.unitPrice,
      sortable: true,
      cell: row => `$${row.unitPrice}`
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="actions-container">
          <button onClick={() => openEditMaterialModal(row)} className="btn btn-info btn-sm" title="Editar">
            <i className="fas fa-pencil-alt"></i> Editar
          </button>
          <button onClick={() => handleDeleteMaterial(row.id)} className="btn btn-danger btn-sm" title="Eliminar">
            <i className="fas fa-trash-alt"></i> Eliminar
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const filteredItems = materials.filter(
    item => item.name.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div className="container-fluid p-0">
      <h1 className="h3 mb-3">Gestión de Materiales Reciclables</h1>
      <div className="card">
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-6 col-xl-4 mb-2 mb-md-0">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar material…"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
            <div className="col-md-6 col-xl-8 text-end">
              <button onClick={openAddMaterialModal} className="btn btn-primary">
                <i className="fas fa-plus-circle"></i> Nuevo Material
              </button>
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredItems}
            pagination
            fixedHeader
            fixedHeaderScrollHeight="450px"
            noDataComponent="No hay materiales registrados"
          />
        </div>
      </div>

      {/* Modal para agregar/editar material con MDBReact */}
      <MDBModal show={modalOpen} setShow={setModalOpen} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{isEditing ? "Editar Material" : "Nuevo Material"}</MDBModalTitle>
              <button type="button" className="btn-close" onClick={toggleModal}></button>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <div className="mb-3">
                  <label className="form-label">Nombre del Material</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedMaterial?.name || ""}
                    onChange={(e) => setSelectedMaterial({ ...selectedMaterial, name: e.target.value })}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Categoría</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedMaterial?.category || ""}
                    onChange={(e) => setSelectedMaterial({ ...selectedMaterial, category: e.target.value })}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Precio por Unidad ($/kg)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={selectedMaterial?.unitPrice || ""}
                    onChange={(e) => setSelectedMaterial({
                      ...selectedMaterial,
                      unitPrice: parseFloat(e.target.value) || 0
                    })}
                  />
                </div>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <button type="button" className="btn btn-primary" onClick={handleSaveMaterial}>
                {isEditing ? "Guardar Cambios" : "Agregar Material"}
              </button>
              <button type="button" className="btn btn-secondary" onClick={toggleModal}>Cancelar</button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  );
};

export default GestionMateriales;
